var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',{attrs:{"title":"Emissão de GR-PR"}},[_c('div'),_c('EmitirGuiaForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }